import script from "./Loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=7310c739&lang=scss"

const __exports__ = script;

export default __exports__